/**
 * Stable API client wrapper (non-generated).
 *
 * This file intentionally lives outside the generated `src/client` folder so that
 * running `npm run openapi-ts` does not overwrite custom logic (auth headers, base URL, etc.).
 *
 * Generated functions under `src/client` are pure and unaware of auth. We provide:
 *  - `authedClient`: a pre-configured client instance with the base URL
 *  - `withAuthHeaders(extra?)`: async helper to merge Firebase ID token into headers
 */
import {
  API_BASE,
  configureApi,
  installRawBodyInterceptor,
} from "@secure-vault/api";
import { createClient, createConfig } from "@secure-vault/api/client-core";
import { auth } from "@/lib/firebase/client";
import { getActiveOrgId } from "@/stores/org-store";

export { API_BASE };

async function buildAuthHeaders() {
  const u = auth.currentUser;
  if (!u) return {} as Record<string, string>;
  const token = await u.getIdToken();
  const headers: Record<string, string> = { Authorization: `Bearer ${token}` };

  const orgId = getActiveOrgId();
  if (orgId) {
    headers["X-Org-Id"] = orgId;
  }

  return headers;
}

export const authedClient = createClient(
  createConfig({
    baseUrl: API_BASE,
  })
);

// Raw-body content-type handling for binary uploads (shared with the vault app).
installRawBodyInterceptor(authedClient);

export async function withAuthHeaders(extra?: Record<string, string>) {
  return { ...(await buildAuthHeaders()), ...(extra || {}) } as Record<
    string,
    string
  >;
}

// Inject this app's auth wiring into the shared @secure-vault/api SDK. The
// advisor app has no vault session token, so that stays defaulted to "".
configureApi({
  client: authedClient,
  getAuthHeaders: withAuthHeaders,
});
